 const ToBooleanText = (id,Header,accessor) => {
    return {
        Header: () => Header,
        id: id,
        Cell: ({ row }) => {
            if(row.original[accessor] === true){
                return 'SI'
            } else{
                return 'NO'
            }
        },
    };
    }
export default ToBooleanText;
